<template>
<fragment>
      <tr v-if="!loading && intervention">
            <td>
                {{ intervention.designation }}
                <span class="d-block ix-text-small ix-text-secondary">{{ intervention.equipment.name }}</span>
            </td>
            <td>
                 <input type="time" class="form-control" :name="'interventions[' +  intervention.id + '][duration]'" v-model="intervention.duration" required :class="{'checking-duration-warning': isLongDuration()}">
                <small v-if="isLongDuration()" class="text-warning d-block mt-1">
                    Pointage anormalement long (&gt; {{ maxHoursPerDay || 12 }}h)
                </small>
            </td>
              <td class="text-right">
                <button type="button" class="ix-btn transparent" @click="openMovementCheckingModal">Sorties de stocks</button>
            </td>
      </tr>
       <tr v-if="intervention.movements && intervention.movements.designation != null" style="background: #0366D6">
        <td colspan="4" class="text-center">
            <span class="d-block text-white"><b>Sorties de stocks</b></span>
        </td>
    </tr>
    <tr v-if="intervention.movements && intervention.movements.designation != null">
        <td colspan="2">
            <span class="d-block ix-text-small ix-text-secondary" v-if="intervention.movements">Motif :
                 <span v-if="intervention.movements.designation"><b>{{ intervention.movements.designation }}</b></span>
                 <span v-if="!intervention.movements.designation"><b>Non renseigné</b></span>
                 <input type="hidden" class="form-control" :name="'interventions[' + intervention.id +'][movements][designation]'" v-model="intervention.movements.designation" />
            </span>
        </td>
        <td class="text-right">
            <span class="d-block ix-text-small ix-text-secondary" v-if="intervention.movements">Le : <b>{{ intervention.movements.date_at }}</b></span>
            <input type="hidden" class="form-control" :name="'interventions[' + intervention.id +'][movements][date_at]'" v-model="intervention.movements.date_at" />
        </td>
    </tr>
      <fragment v-if="intervention.movements">
        <tr v-for="(article, index) in intervention.movements.articles" :key="index">
            <td colspan="2">
                <span class="d-block">
                    {{ article.name }}
                </span>
                 <span class="d-block ix-text-small ix-text-secondary">
                     Quantité : <b>{{ article.quantity }}</b>
                 </span>
                <input type="hidden" class="form-control" :name="'interventions[' + intervention.id +'][movements][articles][' + article.id + '][id]'" v-model="intervention.movements.articles[index].id" />
                <input type="hidden" class="form-control" :name="'interventions[' + intervention.id +'][movements][articles][' + article.id + '][designation]'" v-model="intervention.movements.articles[index].name" />
                <input type="hidden" class="form-control" :name="'interventions[' + intervention.id +'][movements][articles][' + article.id + '][quantity]'" v-model="intervention.movements.articles[index].quantity" />
            </td>
            <td class="text-right">
                  <span class="btn btn-sm transparent" @click="deleteMovement(index)">
                    <i class="far fa-trash"></i>
                </span>
            </td>
        </tr>
    </fragment>
</fragment>
</template>


<script>
export default {
    name: 'precheckings-intervention-form',
    props: ['intervention' , 'index' , 'articleUrl', 'duration', 'maxHoursPerDay'],
    data() {
        return {
            loading: true,
            movements : {
                designation : null,
                date_at : null,
                articles : [],
            },
        }
    },
    methods : {
        compute: function(){
            this.intervention.duration = this.intervention.duration ? this.intervention.duration : this.duration;
            this.intervention.movements = this.intervention.movements ? this.intervention.movements : this.movements;
        },
        deleteMovement(index){
            this.intervention.movements.articles.splice(index , 1);
            if(this.intervention.movements.articles.length == 0){
                this.intervention.movements.designation = null;
                this.intervention.movements.date_at = null;
                this.intervention.movements.articles = [];
            }
        },
        openMovementCheckingModal(){
            this.$emit('open-movement-intervention-checking-modal', {intervention : this.intervention , index : this.index, movements : this.intervention.movements});
        },
        isLongDuration: function() {
            if (!this.intervention || !this.intervention.duration) {
                return false;
            }
            const parts = this.intervention.duration.split(':');
            if (parts.length !== 2) {
                return false;
            }
            const h = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10);
            if (isNaN(h) || isNaN(m)) {
                return false;
            }
            const totalMinutes = h * 60 + m;
            const maxMinutes = (this.maxHoursPerDay || 12) * 60;
            console.log(totalMinutes, maxMinutes, totalMinutes > maxMinutes);
            return totalMinutes > maxMinutes;
        }
    },
     mounted(){
        this.compute();
        this.loading = false;
    }
}
</script>